var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 256,
    viewBox: "0 0 288 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.997 0H71.9991L0 128.011L71.9991 256H215.997L287.996 128.011L215.997 0ZM188.149 206.512H99.8404L55.6897 128.011L99.8404 49.5027H188.149L232.307 128.011L188.149 206.512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure);
export default __webpack_public_path__ + "static/media/figure.77ce1e602fc7cf4729321a179ef5e7b9.svg";
export { ForwardRef as ReactComponent };